@let $titleClasses = computedTitleClasses();

@if (title(); as title) {
  <header class="mbs-form-group_header">
    @switch (titleSize()) {
      @case ('h1') {
        <h1
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h1>
      }
      @case ('h2') {
        <h2
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h2>
      }
      @case ('h3') {
        <h3
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h3>
      }
      @case ('h4') {
        <h4
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h4>
      }
      @case ('h5') {
        <h5
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h5>
      }
      @case ('h6') {
        <h6
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h6>
      }
      @default {
        <h5
          mbsFormTitleClasses
          [titleClasses]="$titleClasses">
          {{ title }}
        </h5>
      }
    }
  </header>
}

<div [class]="computedContentClasses()">
  <ng-content />
</div>
